import { render, staticRenderFns } from "./KnImagesGalleryItem.vue?vue&type=template&id=0b85298b"
import script from "./KnImagesGalleryItem.js?vue&type=script&lang=js&external"
export * from "./KnImagesGalleryItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports